require('flexslider');
function setFooterBottomPadding() {
    if( $('.eligibility-box-mobile .button-container').length && $('.eligibility-box-mobile .button-container').is(':visible') ){
        var boxHeight = $('.eligibility-box-mobile .button-container').outerHeight();
        $('footer.l-footer').css('padding-bottom',boxHeight);
    }
    else {
        $('footer.l-footer').css('padding-bottom',0);
    }
}
$(window).resize(
    function() {
        setFooterBottomPadding();
    }
);

$(window).bind('load', function() {
    var $checkEligibilityBox = $('#eligibility');
    if( $checkEligibilityBox.length ){
        var boxWidth = $checkEligibilityBox.width();
        var boxHeight = $checkEligibilityBox.height();
        var vTop = $checkEligibilityBox.offset().top - parseFloat($checkEligibilityBox.css('margin-top').replace(/auto/, 0));

        $(window).scroll(function (event) {
            var y = $(this).scrollTop();
            if (y >= vTop  ) {
                $checkEligibilityBox.addClass('stick');
                $checkEligibilityBox.css('width',boxWidth);
            }
            else  {
                $checkEligibilityBox.removeClass('stick');
                $checkEligibilityBox.removeAttr('style');
            }
        });
    }
});

if ( $('.flexslider ul li').length) {
    var mainFlexslider = $('.flexslider').flexslider({
        animation: "slide",
        smoothHeight: true,
        slideshow: false,
        animationLoop: false,
        start: function(slider){
            var nextSlide = slider.currentSlide;
            var imageHeight = slider.slides[nextSlide].children[0].clientHeight;
            // $('.flex-control-nav').css('top', imageHeight+20);
            // $('.flex-direction-nav').css('top', imageHeight+20);
            $('.flex-control-nav').css('display', 'block');
            $('.flex-direction-nav').css('display', 'flex');
            $(window).trigger('resize');
        },
        after: function(slider){
            var nextSlide = slider.currentSlide;
            var imageHeight = slider.slides[nextSlide].children[0].clientHeight;
            // $('.flex-control-nav').css('top', imageHeight+20);
            // $('.flex-direction-nav').css('top', imageHeight+20);
            $('.flex-control-nav').css('display', 'block');
            $('.flex-direction-nav').css('display', 'flex');
            $(window).trigger('resize');
        },
        before: function(slider){
            var nextSlide = slider.animatingTo;
            var imageHeight = slider.slides[nextSlide].children[0].clientHeight;
            // $('.flex-control-nav').css('top', imageHeight+20);
            // $('.flex-direction-nav').css('top', imageHeight+20);
        }
    });
}

if ( $('.availability-filters').length){
    $( ".availability-filter" ).change(function() {
        var parent = $(this).parents('.availability-filters');
        var beds = parent.find('.availability-filter.filter-beds').val();
        var status = parent.find('.availability-filter.filter-status').val();

        $('.plot-item').removeClass('hidden');
        $('.load-more-button-holder').addClass('hidden');
        $( ".plot-item" ).each(function( index ) {
            if($(this).hasClass('beds-' + beds) || beds == 'all' ) {
                $(this).removeClass('hidden');
            } else {
                $(this).addClass('hidden');
            }
        });
    });
}

if ( $('.load-more-trigger').length){
    $( ".load-more-trigger" ).click(function(event) {
        event.preventDefault();
        $('.plot-item').removeClass('hidden');
        $('.load-more-button-holder').addClass('hidden-important');
    });
}

if ( $('.plot-short-description').length){
    $(document).on('click', '.plot-short-description', function(event){
        event.preventDefault();
        $(this).toggleClass('open');
        $(this).next('.plot-long-description').slideToggle();
        $(this).next('.plot-long-description').toggleClass('open');
    });
}

if( $('.table-striped').length ) {
    var stripedItems = $('.table-striped tr').length;
    $( '.table-striped tr' ).each(function( index ) {
        if( index == 0 ){
            $(this).addClass('first');
        }
        if( index === stripedItems-1 ){
            $(this).addClass('last');
        }
        if( index % 2 == 0 ){
            $(this).addClass('even');
        }
        else {
            $(this).addClass('odd');
        }
    });
}

$( ".scrollToAvailability" ).click(function(event) {
    event.preventDefault();
    elem = $('#availability');
    headerHeight = $('.sticky').height();
    $('body, html').animate({
        scrollTop: elem.offset().top - headerHeight+"px"
    },500);
});

$('.map-button').on('click', function() {
    $('#map-container').slideToggle();
    $(this).text((i, text) => {return text === 'Show map' ? 'Hide map' : 'Show map';});
    $(this).toggleClass('open');
});



